/* eslint-disable react-hooks/exhaustive-deps */
import { AgGridReact } from 'ag-grid-react';
import { useEffect, useMemo, useRef, useState } from 'react';
import Select from 'react-select';
import MeInvoiceApi from '../services/meinvoice';
import {
  Badge,
  Button,
  Col,
  Container,
  Form,
  Modal,
  Row,
  Table,
} from 'react-bootstrap';
import { toast } from 'react-toastify';
import DrivingServiceInstance from '../services/driving';
import { FUEL_TYPES } from '../constants/meinvoice.constant';
import AdminLogoutButton from '../components/AdminLogoutButton';

function MeInvoiceBatchPage() {
  const DEFAULT_CENTER_ID = '67b4559db586fd615075e72e';
  const [searchText, setSearchText] = useState('');
  const [gridApi, setGridApi] = useState(null);
  const [loading, setLoading] = useState(true);
  // eslint-disable-next-line no-unused-vars
  const [batchData, setBatchData] = useState([]);
  // eslint-disable-next-line no-unused-vars
  const [allBatchData, setAllBatchData] = useState([]);
  const [pagination, setPagination] = useState({
    totalDocs: 0,
    totalPages: 0,
    page: 1,
    limit: 20,
    hasNextPage: false,
    hasPrevPage: false
  });
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedBatch, setSelectedBatch] = useState(null);
  const [showBatchModal, setShowBatchModal] = useState(false);
  const [drivingTeachers, setDrivingTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState({ value: 'all', label: 'Tất cả giáo viên' });
  const [batchLimit, setBatchLimit] = useState(3000000);
  const [batchProcessing, setBatchProcessing] = useState(false);
  const [fuelType, setFuelType] = useState('');
  const [showConfirmUpdateModal, setShowConfirmUpdateModal] = useState(false);
  const [selectedBatchForUpdate, setSelectedBatchForUpdate] = useState(null);
  const [selectedDrivingType, setSelectedDrivingType] = useState('B');
  const [reportStatus, setReportStatus] = useState({ value: 'all', label: 'Tất cả trạng thái' });
  const [reportTeacher, setReportTeacher] = useState({ value: 'all', label: 'Tất cả giáo viên' });
  const [reportDetectedItemType, setReportDetectedItemType] = useState({ value: 'all', label: 'Tất cả loại nhiên liệu' });
  const [reportCreatedStartDate, setReportCreatedStartDate] = useState('');
  const [reportCreatedEndDate, setReportCreatedEndDate] = useState(new Date().toISOString().split('T')[0]);
  const [reportPaidStartDate, setReportPaidStartDate] = useState('');
  const [reportPaidEndDate, setReportPaidEndDate] = useState('');
  const [reportGroupBy, setReportGroupBy] = useState([
    { value: 'GfStudentCourse', label: 'Khóa học' },
    { value: 'DrivingTeacher', label: 'Giáo viên' },
    { value: 'PaidDate', label: 'Ngày thanh toán' },
  ]);
  const [reportFormat, setReportFormat] = useState('xlsx');
  const [pdfTitleTemplate, setPdfTitleTemplate] = useState('');
  const [includeContentColumn, setIncludeContentColumn] = useState(true);
  const [includeBatchCountColumn, setIncludeBatchCountColumn] = useState(false);
  const [includeGfStudentNLQColumn, setIncludeGfStudentNLQColumn] = useState(false);
  const [exporting, setExporting] = useState(false);
  const [showExportModal, setShowExportModal] = useState(false);
  const [showExportPaymentVoucherModal, setShowExportPaymentVoucherModal] = useState(false);
  const [paymentVoucherTeacher, setPaymentVoucherTeacher] = useState({ value: 'all', label: 'Tất cả giáo viên' });
  const [paymentVoucherStartDate, setPaymentVoucherStartDate] = useState('');
  const [paymentVoucherEndDate, setPaymentVoucherEndDate] = useState(new Date().toISOString().split('T')[0]);
  const [paymentVoucherLayout, setPaymentVoucherLayout] = useState('per-invoice-merged');
  const [exportingPaymentVoucher, setExportingPaymentVoucher] = useState(false);
  const [showSingleVoucherModal, setShowSingleVoucherModal] = useState(false);
  const [singleVoucherBatch, setSingleVoucherBatch] = useState(null);
  const [singleVoucherLayout, setSingleVoucherLayout] = useState('per-invoice-merged');
  const drivingTeachersAbortRef = useRef(null);

  const showDetailBatch = (batch) => {
    setSelectedBatch(batch);
    setShowDetailModal(true);
  };

  const getStatusBadgeVariant = (status) => {
    switch (status) {
      case 'paid':
        return 'success';
      case 'pending':
        return 'warning';
      case 'cancelled':
        return 'danger';
      default:
        return 'secondary';
    }
  };

  const getStatusText = (status) => {
    switch (status) {
      case 'paid':
        return 'Đã thanh toán';
      case 'pending':
        return 'Chờ xử lý';
      case 'cancelled':
        return 'Đã hủy';
      default:
        return 'Không xác định';
    }
  };

  const getBatchFuelQuantity = (batch) => {
    const invoices = Array.isArray(batch?.InvoiceIds) ? batch.InvoiceIds : [];

    return invoices.reduce((sum, invoice) => {
      if (typeof invoice !== 'object') return sum;

      const quantity = Number(invoice?.Items?.[0]?.Quantity) || 0;
      return sum + quantity;
    }, 0);
  };

  const hasInvoiceWithMultipleItems = (batch) => {
    const invoices = Array.isArray(batch?.InvoiceIds) ? batch.InvoiceIds : [];

    return invoices.some(
      (invoice) =>
        typeof invoice === 'object' &&
        Array.isArray(invoice?.Items) &&
        invoice.Items.length > 1
    );
  };

  const invoiceHasMultipleItems = (invoice) =>
    typeof invoice === 'object' &&
    Array.isArray(invoice?.Items) &&
    invoice.Items.length > 1;

  const openSingleVoucherModal = (batch) => {
    if (!batch || !batch._id) {
      toast.error('Không tìm thấy thông tin batch');
      return;
    }
    setSingleVoucherBatch(batch);
    setSingleVoucherLayout('per-invoice-merged');
    setShowSingleVoucherModal(true);
  };

  const handleExportPaymentVoucher = async (batch, layout = 'per-invoice-merged') => {
    if (!batch || !batch._id) {
      toast.error('Không tìm thấy thông tin batch');
      return;
    }

    try {
      setExporting(true);
      const response = await MeInvoiceApi.exportPaymentVouchers([batch._id], layout);

      // Extract filename from content-disposition header or use default
      const contentDisposition = response.headers['content-disposition'] || '';
      const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
      const filename = filenameMatch
        ? filenameMatch[1]
        : `phieu_chi_${batch.DrivingTeacher || batch._id}_${Date.now()}.xlsx`;

      // Create blob and download (Excel spreadsheet)
      const blob = new Blob([response.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success('Xuất phiếu chi thành công');
      setShowSingleVoucherModal(false);
    } catch (error) {
      console.error('Export payment voucher error:', error);
      toast.error(error?.response?.data?.message || 'Xuất phiếu chi thất bại');
    } finally {
      setExporting(false);
    }
  };

  const handleShowConfirmUpdate = (batch) => {
    setSelectedBatchForUpdate(batch);
    // Set default driving type based on fuel type
    setSelectedDrivingType(batch?.DetectedItemType === 'DIESEL' ? 'C1' : 'B');
    setShowConfirmUpdateModal(true);
  };

  const updateStudentForInvoiceBatch = async () => {
    try {
      setBatchProcessing(true);
      await MeInvoiceApi.updateStudentForBatch(selectedBatchForUpdate?._id, selectedDrivingType);
      toast.success('Cập nhật thành công');
      fetchBatchData();
      setShowConfirmUpdateModal(false);
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Cập nhật thất bại');
    } finally {
      setBatchProcessing(false);
      setSelectedBatchForUpdate(null);
      setShowConfirmUpdateModal(false);
    }
  };

  // Đồng bộ GV-BC1 / XE-BC1 từ GetFly cho batch (cho batch cũ chưa có 2 field).
  const handleSyncBc1 = async (batch) => {
    if (!batch?._id) return;
    if (!batch.GfStudentId) {
      toast.warning('Batch chưa gắn học viên — không thể đồng bộ GV/XE BC1.');
      return;
    }
    try {
      setBatchProcessing(true);
      const res = await MeInvoiceApi.syncBc1ForBatch(batch._id, { force: true });
      const d = res?.data?.data || {};
      toast.success(`Đồng bộ GV/XE BC1: GV="${d.GfStudentTeacherBc1 || '-'}", XE="${d.GfStudentVehicleBc1 || '-'}"`);
      fetchBatchData();
    } catch (error) {
      toast.error(error?.response?.data?.message || 'Đồng bộ GV/XE BC1 thất bại');
    } finally {
      setBatchProcessing(false);
    }
  };

  const handleDeleteBatch = async (batchId, status) => {
    if (!batchId) return;
    if (status !== 'pending') {
      toast.warning('Chỉ được xoá batch ở trạng thái pending. Vui lòng xoá học viên trước.');
      return;
    }

    const confirmDelete = window.confirm('Bạn có chắc muốn xoá batch này?');
    if (!confirmDelete) return;

    const deletedReason = window.prompt('Nhập lý do xoá (bắt buộc):', '');
    if (deletedReason === null) return; // User clicked Cancel

    if(deletedReason.trim() === '') {
      toast.error('Lý do xoá là bắt buộc.');
      return;
    }

    try {
      await MeInvoiceApi.deleteMeInvoiceBatch(batchId, deletedReason || '');
      toast.success('Đã xoá batch');
      
      // Refresh grid datasource instead of fetchBatchData
      if (gridApi) {
        const dataSource = getDataSourceBatch(searchText);
        try {
          if (typeof gridApi.setDatasource === 'function') {
            gridApi.setDatasource(dataSource);
          } else if (typeof gridApi.setGridOption === 'function') {
            gridApi.setGridOption('datasource', dataSource);
          }
        } catch (e) {
          console.warn('Failed to refresh batch datasource', e);
        }
      }
    } catch (error) {
      console.error('Delete batch error:', error);
      toast.error(error?.response?.data?.message || 'Xoá batch thất bại');
    }
  };

  const handleRemoveStudentFromPaidBatch = async (batchId, status) => {
    if (!batchId) return;
    if (status !== 'paid') {
      toast.warning('Chỉ áp dụng xoá học viên cho batch đã thanh toán (paid).');
      return;
    }

    const confirmDelete = window.confirm('Xoá học viên khỏi batch đã thanh toán? Hành động này sẽ xoá thông tin học viên khỏi batch và đặt batch về trạng thái chờ xử lý.');
    if (!confirmDelete) return;

    try {
      await MeInvoiceApi.removeStudentFromBatch(batchId);
      toast.success('Đã xoá học viên khỏi batch, batch về trạng thái chờ xử lý.');
      
      // Refresh grid datasource instead of fetchBatchData
      if (gridApi) {
        const dataSource = getDataSourceBatch(searchText);
        try {
          if (typeof gridApi.setDatasource === 'function') {
            gridApi.setDatasource(dataSource);
          } else if (typeof gridApi.setGridOption === 'function') {
            gridApi.setGridOption('datasource', dataSource);
          }
        } catch (e) {
          console.warn('Failed to refresh batch datasource', e);
        }
      }
    } catch (error) {
      console.error('Remove student from batch error:', error);
      toast.error(error?.response?.data?.message || 'Xoá học viên thất bại');
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const colDefs = useMemo(
    () => [
      {
        headerName: 'STT',
        valueGetter: (params) =>
          params?.node?.rowIndex != null ? params.node.rowIndex + 1 : '',
        width: 80,
        pinned: 'left',
      },
      {
        field: 'GfStudentCode',
        headerName: 'Thao tác',
        pinned: 'left',
        cellRenderer: (params) => {
          return (
            <div>
              {!params.value ? (
                <Button onClick={() => handleShowConfirmUpdate(params.data)}>
                  Chốt chi
                </Button>
              ) : (
                <>
                  <Button variant='secondary' onClick={() => openSingleVoucherModal(params.data)}>
                    Xuất phiếu chi
                  </Button>
                  <Button
                    size='sm'
                    variant='outline-info'
                    className='ms-1'
                    title='Đồng bộ GV - BC1 / XE - BC1 từ GetFly'
                    disabled={batchProcessing}
                    onClick={() => handleSyncBc1(params.data)}
                  >
                    Đồng bộ GV/XE
                  </Button>
                </>
              )}
            </div>
          );
        },
      },
      {
        field: 'GfStudentCode',
        headerName: 'Mã học viên',
      },
      {
        field: 'DrivingTeacher',
        headerName: 'Người nhận nhiên liệu',
        width: 200,
      },
      {
        field: 'DetectedItemType',
        headerName: 'Loại nhiên liệu',
        width: 200,
        cellRenderer: (params) => {
          const type = params.value;
          if (type === 'GASOLINE') return 'Xăng';
          if (type === 'DIESEL') return 'Dầu diesel';
          if (type === 'OTHER') return 'Khác';
          return '';
        },
      },
      {
        field: 'GfStudentName',
        headerName: 'Tên học viên',
        width: 250,
      },
      {
        field: 'GfStudentCourse',
        headerName: 'Khóa học',
        width: 250,
      },
      {
        field: 'GfStudentTeacherBc1',
        headerName: 'GV - BC1',
        width: 180,
      },
      {
        field: 'GfStudentVehicleBc1',
        headerName: 'XE - BC1',
        width: 140,
      },
      {
        field: 'GfStudentDate',
        headerName: 'Ngày xuống hình',
        width: 200,
      },
      {
        field: 'GfStudentKhaiGiangDate',
        headerName: 'Ngày khai giảng',
        width: 200,
      },
      {
        field: 'TotalAmount',
        headerName: 'Tổng tiền',
        minWidth: 150,
        flex: 1,
        valueFormatter: (params) => {
          return new Intl.NumberFormat('vi-VN', {
            style: 'currency',
            currency: 'VND',
          }).format(params.value || 0);
        },
      },
      {
        headerName: 'Tổng lít xăng/dầu',
        minWidth: 180,
        flex: 1,
        valueGetter: (params) => getBatchFuelQuantity(params.data),
        cellStyle: (params) => {
          if (!hasInvoiceWithMultipleItems(params.data)) return null;

          return {
            backgroundColor: '#fff3cd',
            color: '#664d03',
            fontWeight: 600,
          };
        },
        valueFormatter: (params) => {
          const value = Number(params.value) || 0;
          return `${value.toLocaleString('vi-VN', {
            minimumFractionDigits: 0,
            maximumFractionDigits: 2,
          })} lít`;
        },
      },
      {
        field: 'RemainingAmount',
        headerName: 'Số tiền còn lại',
        minWidth: 150,
        flex: 1,
        valueFormatter: (params) => {
          return new Intl.NumberFormat('vi-VN', {
            style: 'currency',
            currency: 'VND',
          }).format(params.value || 0);
        },
      },
      {
        field: 'InvoiceCount',
        headerName: 'Số hóa đơn',
        minWidth: 120,
        flex: 1,
        cellRenderer: (params) => {
          const invoiceCount = params.value || 0;
          const invoices = params.data?.InvoiceIds || [];
          const totalInvoiceAmount = invoices.reduce((sum, inv) => {
            return sum + (typeof inv === 'object' ? inv.TotalAmount || 0 : 0);
          }, 0);

          return (
            <div>
              <Button
                variant='link'
                onClick={() => showDetailBatch(params.data)}
                className='p-0 mb-1'
              >
                {invoiceCount} hóa đơn
              </Button>
              {totalInvoiceAmount > 0 && (
                <div>
                  <small className='text-muted'>
                    Tổng:{' '}
                    {new Intl.NumberFormat('vi-VN', {
                      style: 'currency',
                      currency: 'VND',
                    }).format(totalInvoiceAmount)}
                  </small>
                </div>
              )}
            </div>
          );
        },
      },
      {
        field: '_id',
        headerName: 'Batch ID',
        width: 250,
      },
      {
        field: 'Status',
        headerName: 'Trạng thái',
        minWidth: 150,
        flex: 1,
        cellRenderer: (params) => {
          return (
            <Badge bg={getStatusBadgeVariant(params.value)} className='p-2'>
              {getStatusText(params.value)}
            </Badge>
          );
        },
      },
      {
        field: 'PaidDate',
        headerName: 'Ngày thanh toán',
        flex: 1,
        minWidth: 150,
        valueFormatter: (params) => {
          if (!params.value) return 'Chưa thanh toán';
          return new Date(params.value).toLocaleDateString('vi-VN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          });
        },
      },
      {
        field: 'createdAt',
        headerName: 'Ngày tạo',
        flex: 1,
        minWidth: 150,
        valueFormatter: (params) => {
          return new Date(params.value).toLocaleDateString('vi-VN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          });
        },
      },
      {
        field: 'updatedAt',
        headerName: 'Cập nhật vào lúc',
        flex: 1,
        minWidth: 150,
        valueFormatter: (params) => {
          return new Date(params.value).toLocaleDateString('vi-VN', {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
          });
        },
      },
      {
        headerName: '',
        width: 140,
        pinned: 'right',
        cellRenderer: (params) => (
          <div className='d-flex flex-column gap-1'>
            {params.data?.Status === 'pending' && (
              <Button
                variant='danger'
                size='sm'
                onClick={() => handleDeleteBatch(params.data?._id, params.data?.Status)}
                disabled={loading}
              >
                Xoá batch
              </Button>
            )}
            {params.data?.Status === 'paid' && (
              <Button
                variant='outline-danger'
                size='sm'
                onClick={() => handleRemoveStudentFromPaidBatch(params.data?._id, params.data?.Status)}
                disabled={loading}
              >
                Xoá học viên
              </Button>
            )}
          </div>
        ),
      },
    ],
    [loading, handleDeleteBatch]
  );

  const onGridReady = (params) => {
    setGridApi(params.api);
    // set infinite datasource when grid ready
    const dataSource = getDataSourceBatch();
    try {
      if (typeof params.api.setDatasource === 'function') {
        params.api.setDatasource(dataSource);
      } else if (typeof params.api.setGridOption === 'function') {
        params.api.setGridOption('datasource', dataSource);
      }
    } catch (e) {
      console.warn('Failed to set batch datasource', e);
    }
  };

  const getDataSourceBatch = (search) => {
    return {
      rowCount: null,
      getRows: async (params) => {
        const { startRow, endRow } = params;
        try {
          const pageSize = Math.max(1, endRow - startRow);
          const page = Math.floor(startRow / pageSize) + 1;
          const limit = pageSize;

          const res = await MeInvoiceApi.getMeInvoiceBatches(page, limit, search);
          params.successCallback(res.data, res.pagination.totalDocs);
        } catch (error) {
          console.error('Batch datasource getRows failed', error);
          params.failCallback();
        }
      },
    };
  };

  const fetchBatchData = async (page = 1, limit = 50, search = '') => {
    setLoading(true);
    try {
      const res = await MeInvoiceApi.getMeInvoiceBatches(page, limit, search);
      
      // Handle the API response structure
      if (res.data && res.data.docs) {
  setBatchData(res.data.docs);
  setAllBatchData(res.data.docs);
        setPagination({
          totalDocs: res.data.totalDocs || 0,
          totalPages: res.data.totalPages || 0,
          page: res.data.page || 1,
          limit: res.data.limit || 10,
          hasNextPage: res.data.hasNextPage || false,
          hasPrevPage: res.data.hasPrevPage || false
        });
      } else {
        // Fallback for different API response structure
  setBatchData(res.data || []);
  setAllBatchData(res.data || []);
        setPagination({
          totalDocs: (res.data || []).length,
          totalPages: 1,
          page: 1,
          limit: (res.data || []).length,
          hasNextPage: false,
          hasPrevPage: false
        });
      }
    } catch (error) {
      console.error('Error fetching batch data:', error);
      toast.error('Lỗi khi tải dữ liệu batch');
      setBatchData([]);
      setAllBatchData([]);
      setPagination({
        totalDocs: 0,
        totalPages: 0,
        page: 1,
        limit: 10,
        hasNextPage: false,
        hasPrevPage: false
      });
    } finally {
      setLoading(false);
    }
  };

  const handleSearch = () => {
    setLoading(true);
    try {
      // perform server-side search using infinite datasource
      if (gridApi) {
        const dataSource = getDataSourceBatch(searchText);
        try {
          if (typeof gridApi.setDatasource === 'function') {
            gridApi.setDatasource(dataSource);
          } else if (typeof gridApi.setGridOption === 'function') {
            gridApi.setGridOption('datasource', dataSource);
          }
          try { if (typeof gridApi.paginationGoToFirstPage === 'function') gridApi.paginationGoToFirstPage(); } catch (e) {}
        } catch (e) {
          console.warn('Failed to set batch datasource on search', e);
        }
      } else {
        // fallback to older fetch if grid not ready
        fetchBatchData(1, pagination.limit, searchText);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const refreshData = async () => {
    await fetchBatchData(pagination.page || 1, pagination.limit || 50, searchText);
    toast.success('Dữ liệu đã được làm mới');
  };

  const reportGroupByOptions = [
    { value: 'GfStudentCourse', label: 'Khóa học' },
    { value: 'DrivingTeacher', label: 'Giáo viên' },
    { value: 'PaidDate', label: 'Ngày thanh toán' },
    { value: 'DetectedItemType', label: 'Loại nhiên liệu' },
  ];

  const fuelTypeOptions = [
    { value: 'all', label: 'Tất cả loại nhiên liệu' },
    { value: 'GASOLINE', label: FUEL_TYPES?.GASOLINE || 'Xăng' },
    { value: 'DIESEL', label: FUEL_TYPES?.DIESEL || 'Dầu diesel' },
    { value: 'OTHER', label: FUEL_TYPES?.OTHER || 'Khác' },
  ];

  const getSelectedGroupByValues = () => (reportGroupBy || []).map((item) => item.value);

  const buildReportQuery = () => {
    const query = {};
    query.Center = DEFAULT_CENTER_ID;

    if (reportStatus?.value && reportStatus.value !== 'all') {
      query.Status = reportStatus.value;
    }

    if (reportTeacher?.value && reportTeacher.value !== 'all') {
      query.DrivingTeacher = reportTeacher.value;
    }

    if (reportDetectedItemType?.value && reportDetectedItemType.value !== 'all') {
      query.DetectedItemType = reportDetectedItemType.value;
    }

    if (reportCreatedStartDate || reportCreatedEndDate) {
      const createdAt = {};
      if (reportCreatedStartDate) {
        createdAt.$gte = new Date(reportCreatedStartDate + 'T00:00:00.000Z').toISOString();
      }
      if (reportCreatedEndDate) {
        createdAt.$lte = new Date(reportCreatedEndDate + 'T23:59:59.999Z').toISOString();
      }
      query.createdAt = createdAt;
    }

    if (reportPaidStartDate || reportPaidEndDate) {
      const paidDate = {};
      if (reportPaidStartDate) {
        paidDate.$gte = new Date(reportPaidStartDate + 'T00:00:00.000Z').toISOString();
      }
      if (reportPaidEndDate) {
        paidDate.$lte = new Date(reportPaidEndDate + 'T23:59:59.999Z').toISOString();
      }
      query.PaidDate = paidDate;
    }

    return query;
  };


  const exportBatches = async () => {
    const groupBy = getSelectedGroupByValues();
    const query = buildReportQuery();

    if (reportCreatedStartDate && reportCreatedEndDate) {
      const startDateObj = new Date(reportCreatedStartDate);
      const endDateObj = new Date(reportCreatedEndDate);
      if (startDateObj > endDateObj) {
        toast.error('Ngày bắt đầu (ngày tạo) không được lớn hơn ngày kết thúc');
        return;
      }
    }

    if (reportPaidStartDate && reportPaidEndDate) {
      const startDateObj = new Date(reportPaidStartDate);
      const endDateObj = new Date(reportPaidEndDate);
      if (startDateObj > endDateObj) {
        toast.error('Ngày bắt đầu (ngày thanh toán) không được lớn hơn ngày kết thúc');
        return;
      }
    }

    setExporting(true);
    try {
      const filter = {
        filter: { query },
        options: {
          groupBy,
          format: reportFormat,
          ...(pdfTitleTemplate?.trim()
            ? { pdfTitleTemplate: pdfTitleTemplate.trim() }
            : {}),
          includeContentColumn,
          includeBatchCountColumn,
          includeGfStudentNLQColumn,
          sort: { createdAt: -1 },
        },
      };

      const response = await MeInvoiceApi.exportMeInvoiceBatches(filter);

      const contentDisposition = response.headers['content-disposition'] || '';
      const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
      const defaultExt = reportFormat === 'pdf' ? 'pdf' : 'xlsx';
      const filename = filenameMatch ? filenameMatch[1] : `bao_cao_dot_chi_${Date.now()}.${defaultExt}`;

      const mimeType =
        reportFormat === 'pdf'
          ? 'application/pdf'
          : 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet';

      const blob = new Blob([response.data], { type: mimeType });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success('Xuất báo cáo thành công');
    } catch (error) {
      console.error('Export error:', error);
      const warningHeader = error.response?.headers?.['x-export-warning'];
      if (warningHeader) {
        toast.warning(`Xuất báo cáo: ${warningHeader}`);
      } else {
        toast.error(error?.response?.data?.message || 'Xuất báo cáo thất bại');
      }
    } finally {
      setExporting(false);
    }
  };

  const exportMultiBatchPaymentVouchers = async () => {
    if (!paymentVoucherStartDate || !paymentVoucherEndDate) {
      toast.error('Vui lòng chọn khoảng thời gian');
      return;
    }

    setExportingPaymentVoucher(true);
    try {
      // Build query params to match controller: {_page,_limit,...query}
      const startISO = new Date(paymentVoucherStartDate);
      startISO.setHours(0, 0, 0, 0);
      const endISO = new Date(paymentVoucherEndDate);
      endISO.setHours(23, 59, 59, 999);

      const query = {
        Status: 'paid',
        PaidDate: {
          $gte: startISO.toISOString(),
          $lte: endISO.toISOString(),
        },
      };

      if (paymentVoucherTeacher && paymentVoucherTeacher.value !== 'all') {
        query.DrivingTeacher = paymentVoucherTeacher.value;
      }

      // Fetch all batches matching the filter criteria using query params
      const response = await MeInvoiceApi.queryMeInvoiceBatches(1, 10000, query);
      const allBatches = response.data || [];

      if (allBatches.length === 0) {
        toast.warning('Không tìm thấy batch nào phù hợp với điều kiện');
        return;
      }

      // Extract batch IDs
      const batchIds = allBatches.map(batch => batch._id);

      // Call export API
      const exportResponse = await MeInvoiceApi.exportPaymentVouchers(batchIds, paymentVoucherLayout);

      // Extract filename from content-disposition header or use default
      const contentDisposition = exportResponse.headers['content-disposition'] || '';
      const filenameMatch = contentDisposition.match(/filename="?([^";\n]+)"?/);
      const filename = filenameMatch 
        ? filenameMatch[1] 
        : `phieu_chi_${paymentVoucherTeacher.value !== 'all' ? paymentVoucherTeacher.value : 'multi'}_${Date.now()}.xlsx`;

      // Create blob and download (Excel spreadsheet)
      const blob = new Blob([exportResponse.data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      });
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      toast.success(`Xuất phiếu chi thành công cho ${allBatches.length} batch`);
      setShowExportPaymentVoucherModal(false);
    } catch (error) {
      console.error('Export payment vouchers error:', error);
      toast.error(error?.response?.data?.message || 'Xuất phiếu chi thất bại');
    } finally {
      setExportingPaymentVoucher(false);
    }
  };

  const fetchDrivingTeachers = async () => {
    // Cancel previous in-flight request (if any) to avoid browser "canceled" errors
    if (drivingTeachersAbortRef.current) {
      drivingTeachersAbortRef.current.abort();
    }

    const controller = new AbortController();
    drivingTeachersAbortRef.current = controller;

    try {
      const res = await DrivingServiceInstance.listInvoiceDrivingTeachers(1, 200, controller.signal);
      setDrivingTeachers(res.data || []);
    } catch (error) {
      const msg = error?.message?.toLowerCase() || '';
      // Ignore user-initiated cancellations (closing modal, navigation, unmount)
      if (error?.code === 'ERR_CANCELED' || msg.includes('canceled') || msg.includes('aborted')) {
        return;
      }
      console.error('Error fetching driving teachers:', error);
      setDrivingTeachers([]);
      toast.error('Lỗi khi tải danh sách giáo viên');
    } finally {
      drivingTeachersAbortRef.current = null;
    }
  };

  const openBatchModal = () => {
    setShowBatchModal(true);
    if (drivingTeachers.length === 0) {
      fetchDrivingTeachers();
    }
  };

  const closeBatchModal = () => {
    if (drivingTeachersAbortRef.current) {
      drivingTeachersAbortRef.current.abort();
      drivingTeachersAbortRef.current = null;
    }
    setShowBatchModal(false);
    setSelectedTeacher({ value: 'all', label: 'Tất cả giáo viên' });
    setBatchLimit(3000000);
  };

  const confirmAndRunBatch = () => {
    if(!batchLimit || batchLimit <= 0) {
      toast.error('Vui lòng nhập số tiền hợp lệ lớn hơn 0');
      return;
    }

    if(!fuelType) {
      toast.error('Vui lòng chọn loại nhiên liệu');
      return;
    }

    const teacherText = selectedTeacher && selectedTeacher.value === 'all'
      ? 'tất cả giáo viên'
      : `giáo viên "${selectedTeacher?.label || selectedTeacher?.value}"`;
    const limitText = new Intl.NumberFormat('vi-VN', {
      style: 'currency',
      currency: 'VND',
    }).format(batchLimit);

    const confirmMessage = `Bạn có chắc chắn muốn Nhóm hoá đơn ${FUEL_TYPES[fuelType].toLocaleUpperCase()} cho ${teacherText} với số tiền ${limitText}?\n\nLưu ý: Thao tác này sẽ tạo ra các batch mới và không thể hoàn tác.`;

    if (window.confirm(confirmMessage)) {
      runMeInvoiceBatch();
    }
  };

  const runMeInvoiceBatch = async () => {
    setBatchProcessing(true);
    try {
      if (selectedTeacher && selectedTeacher.value === 'all') {
        // Run batch for all teachers
        await MeInvoiceApi.runMeInvoiceBatches(batchLimit, fuelType);
      } else {
        // Run batch for specific teacher (pass value: code or id)
        const teacherValue = selectedTeacher?.value;
        await MeInvoiceApi.runMeInvoiceBatchForTeacher(teacherValue, batchLimit, fuelType);
      }

      toast.success('Nhóm hoá đơn thành công');

      // Refresh the batch data after running the batch
      await fetchBatchData(pagination.page || 1, pagination.limit || 50, searchText);
      closeBatchModal();
    } catch (error) {
      console.error(error);
      toast.error('Nhóm hoá đơn thất bại');
    } finally {
      setBatchProcessing(false);
    }
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    document.title = 'Quản lý nhóm hóa đơn | eDriving';
    // Read `search` param from URL and fetch with server-side search if present
    try {
      const params = new URLSearchParams(window.location.search);
      const q = params.get('search');
      if (q) {
        setSearchText(q);
        fetchBatchData(1, pagination.limit, q);
        return;
      }
    } catch (e) {
      // ignore
    }

    // default fetch
    fetchBatchData();
  }, []);

  // Load teachers when export modal opens
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (showExportModal && drivingTeachers.length === 0) {
      fetchDrivingTeachers();
    }
  }, [showExportModal]);

  // Load teachers when payment voucher export modal opens
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    if (showExportPaymentVoucherModal && drivingTeachers.length === 0) {
      fetchDrivingTeachers();
    }
  }, [showExportPaymentVoucherModal]);

  // remove direct rowData updates — grid uses infinite datasource now


  return (
    <>
      <Container
        style={{
          height: '100vh',
        }}
        fluid
      >
        <Row style={{ height: '8%' }} className='align-items-end position-relative'>
          <h2 className='text-center mb-0'>QUẢN LÝ NHÓM HOÁ ĐƠN</h2>
          <div className='position-absolute end-0 bottom-0 pe-3' style={{ width: 'auto' }}>
            <AdminLogoutButton />
          </div>
        </Row>
        <Row style={{ height: '10%' }} className='align-items-center'>
          <Col xs={12} md={7}>
            <Form.Control
              className='mb-3'
              type='text'
              placeholder='Nhập tên giáo viên, batch ID hoặc trạng thái'
              value={searchText}
              onChange={(e) => {
                setSearchText(e.target.value);
              }}
              onKeyPress={(e) => {
                if (e.key === 'Enter') {
                  handleSearch();
                }
              }}
            />
          </Col>
          <Col xs={12} md={1}>
            <Button
              onClick={handleSearch}
              variant='primary'
              disabled={loading}
              className='w-100 mb-3'
            >
              Tìm kiếm
            </Button>
          </Col>
          <Col xs={12} md={1}>
            <Button
              onClick={refreshData}
              variant='success'
              disabled={loading}
              className='w-100 mb-3'
            >
              Làm mới
            </Button>
          </Col>
          <Col xs={12} md={1}>
            <Button
              onClick={openBatchModal}
              variant='warning'
              disabled={loading}
              className='w-100 mb-3'
            >
              Nhóm hoá đơn
            </Button>
          </Col>
          <Col xs={12} md={1}>
            <Button
              onClick={() => setShowExportModal(true)}
              variant='info'
              disabled={loading}
              className='w-100 mb-3'
            >
              Xuất báo cáo
            </Button>
          </Col>
          <Col xs={12} md={1}>
            <Button
              onClick={() => setShowExportPaymentVoucherModal(true)}
              variant='info'
              disabled={loading}
              className='w-100 mb-3'
            >
              Xuất phiếu chi
            </Button>
          </Col>
        </Row>

        {!loading && (
          <Row className='ag-theme-quartz' style={{ height: '78%' }}>
            <AgGridReact
              key={`grid-${drivingTeachers.length}`}
              columnDefs={colDefs}
              defaultColDef={{
                resizable: true,
                sortable: true,
                filter: true,
              }}
              pagination={true}
              paginationPageSize={10}
              rowModelType={'infinite'}
              cacheBlockSize={10}
              paginationPageSizeSelector={[10, 25, 50, 100]}
              onGridReady={onGridReady}
              animateRows={true}
            />
          </Row>
        )}
        {loading && (
          <Row
            className='justify-content-center align-items-center'
            style={{ height: '78%' }}
          >
            <div className='text-center'>
              <div className='spinner-border' role='status'>
                <span className='visually-hidden'>Đang tải...</span>
              </div>
              <p className='mt-2'>Đang tải dữ liệu batch...</p>
            </div>
          </Row>
        )}
      </Container>

      {/* Detail Modal */}
      <Modal
        show={showDetailModal}
        onHide={() => setShowDetailModal(false)}
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>Chi tiết Nhóm hoá đơn</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {selectedBatch ? (
            <>
              <Row className='mb-3'>
                <Col md={6}>
                  <p>
                    <strong>Batch ID:</strong> {selectedBatch._id}
                  </p>
                  <p>
                    <strong>Người nhận nhiên liệu:</strong>{' '}
                    {selectedBatch.DrivingTeacher}
                  </p>
                  <p>
                    <strong>Trạng thái:</strong>{' '}
                    <Badge
                      bg={getStatusBadgeVariant(selectedBatch.Status)}
                      className='p-2'
                    >
                      {getStatusText(selectedBatch.Status)}
                    </Badge>
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    <strong>Tổng tiền:</strong>{' '}
                    {new Intl.NumberFormat('vi-VN', {
                      style: 'currency',
                      currency: 'VND',
                    }).format(selectedBatch.TotalAmount || 0)}
                  </p>
                  <p>
                    <strong>Số tiền còn lại:</strong>{' '}
                    {new Intl.NumberFormat('vi-VN', {
                      style: 'currency',
                      currency: 'VND',
                    }).format(selectedBatch.RemainingAmount || 0)}
                  </p>
                  <p>
                    <strong>Số lượng hóa đơn:</strong>{' '}
                    {selectedBatch.InvoiceCount || 0}
                  </p>
                </Col>
              </Row>

              {/* Invoice Statistics */}
              {selectedBatch.InvoiceIds &&
                selectedBatch.InvoiceIds.length > 0 && (
                  <Row className='mb-3'>
                    <Col>
                      <div className='border rounded p-2 bg-light'>
                        <h6 className='mb-2'>Thống kê hóa đơn:</h6>
                        <Row>
                          <Col md={6}>
                            <small>
                              <strong>Tổng tiền hóa đơn:</strong>
                            </small>
                            <br />
                            <small className='text-success'>
                              {new Intl.NumberFormat('vi-VN', {
                                style: 'currency',
                                currency: 'VND',
                              }).format(
                                selectedBatch.InvoiceIds.reduce(
                                  (sum, inv) =>
                                    sum +
                                    (typeof inv === 'object'
                                      ? inv.TotalAmount || 0
                                      : 0),
                                  0
                                )
                              )}
                            </small>
                          </Col>
                          <Col md={6}>
                            <small>
                              <strong>Tổng đã chi:</strong>
                            </small>
                            <br />
                            <small className='text-info'>
                              {new Intl.NumberFormat('vi-VN', {
                                style: 'currency',
                                currency: 'VND',
                              }).format(
                                selectedBatch.InvoiceIds.reduce(
                                  (sum, inv) =>
                                    sum +
                                    (typeof inv === 'object'
                                      ? inv.InternalPaidAmount || 0
                                      : 0),
                                  0
                                )
                              )}
                            </small>
                          </Col>
                        </Row>
                      </div>
                    </Col>
                  </Row>
                )}

              <Row className='mb-3'>
                <Col md={6}>
                  <p>
                    <strong>Ngày tạo:</strong>{' '}
                    {new Date(selectedBatch.createdAt).toLocaleDateString(
                      'vi-VN',
                      {
                        year: 'numeric',
                        month: '2-digit',
                        day: '2-digit',
                        hour: '2-digit',
                        minute: '2-digit',
                      }
                    )}
                  </p>
                </Col>
                <Col md={6}>
                  <p>
                    <strong>Ngày thanh toán:</strong>{' '}
                    {selectedBatch.PaidDate
                      ? new Date(selectedBatch.PaidDate).toLocaleDateString(
                          'vi-VN',
                          {
                            year: 'numeric',
                            month: '2-digit',
                            day: '2-digit',
                            hour: '2-digit',
                            minute: '2-digit',
                          }
                        )
                      : 'Chưa thanh toán'}
                  </p>
                </Col>
              </Row>

              <h5>Danh sách hóa đơn chi tiết:</h5>
              <p className='text-warning mb-3'>
                <strong>Lưu ý:</strong> Tổng số lít xăng/dầu sẽ chỉ được tính với hàng hoá đầu tiên của mỗi hoá đơn, các hoá đơn có nhiều hơn 1 hàng hoá sẽ được in màu vàng
              </p>
              {selectedBatch.InvoiceIds &&
              selectedBatch.InvoiceIds.length > 0 ? (
                <Table striped bordered hover size='sm'>
                  <thead>
                    <tr>
                      <th>STT</th>
                      <th>ID hóa đơn</th>
                      <th>Số hóa đơn</th>
                      <th>Ngày hóa đơn</th>
                      <th>Tổng tiền</th>
                      <th>Đã chi</th>
                      <th>Số lít xăng/dầu</th>
                    </tr>
                  </thead>
                  <tbody>
                    {selectedBatch.InvoiceIds.map((invoice, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>
                          <a
                            href={`/admin/meinvoice?search=${
                              typeof invoice === 'object'
                                ? invoice._id || invoice
                                : invoice
                            }`}
                            target='_blank'
                            rel='noopener noreferrer'
                          >
                            <small>
                              {invoice?._id || 'N/A'}
                            </small>
                          </a>
                        </td>
                        <td>
                          <small>{invoice?.InvoiceNo || 'N/A'}</small>
                        </td>
                        <td>
                          {typeof invoice === 'object' && invoice.InvoiceDate
                            ? new Date(invoice.InvoiceDate).toLocaleDateString(
                                'vi-VN',
                                {
                                  year: 'numeric',
                                  month: '2-digit',
                                  day: '2-digit',
                                }
                              )
                            : 'N/A'}
                        </td>
                        <td>
                          {typeof invoice === 'object' && invoice.TotalAmount
                            ? new Intl.NumberFormat('vi-VN', {
                                style: 'currency',
                                currency: 'VND',
                              }).format(invoice.TotalAmount)
                            : 'N/A'}
                        </td>
                        <td>
                          {typeof invoice === 'object' &&
                          invoice.InternalPaidAmount
                            ? new Intl.NumberFormat('vi-VN', {
                                style: 'currency',
                                currency: 'VND',
                              }).format(invoice.InternalPaidAmount)
                            : 'N/A'}
                        </td>
                        <td>
                          {typeof invoice === 'object' &&
                          invoice?.Items?.[0]?.Quantity != null
                            ? (
                              <span
                                style={
                                  invoiceHasMultipleItems(invoice)
                                    ? {
                                        backgroundColor: '#fff3cd',
                                        color: '#664d03',
                                        fontWeight: 600,
                                        padding: '2px 6px',
                                        borderRadius: '4px',
                                      }
                                    : undefined
                                }
                              >
                                {`${new Intl.NumberFormat('vi-VN', {
                                  minimumFractionDigits: 0,
                                  maximumFractionDigits: 2,
                                }).format(Number(invoice.Items[0].Quantity) || 0)} lít`}
                              </span>
                            )
                            : 'N/A'}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </Table>
              ) : (
                <p>Không có hóa đơn nào trong nhóm này.</p>
              )}

              {selectedBatch.SplitInvoiceId && (
                <div className='mt-3'>
                  <p>
                    <strong>Hóa đơn tách:</strong>{' '}
                    <a
                      href={`/admin/meinvoice?search=${selectedBatch.SplitInvoiceId?._id || ''}`}
                      target='_blank'
                      rel='noopener noreferrer'
                    >
                      <small>{selectedBatch.SplitInvoiceId?._id || 'N/A'}</small>
                    </a>
                  </p>
                </div>
              )}
            </>
          ) : (
            <p>Đang tải...</p>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowDetailModal(false)}>
            Đóng
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Batch Modal */}
      <Modal show={showBatchModal} onHide={closeBatchModal}>
        <Modal.Header closeButton>
          <Modal.Title>Nhóm hoá đơn</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className='mb-3'>
              <Form.Label>Chọn giáo viên</Form.Label>
              <Select
                options={
                  [
                    { value: 'all', label: 'Tất cả giáo viên' },
                    ...drivingTeachers.map((teacher) => ({
                      value: teacher.code || teacher._id,
                      label: teacher.code || teacher._id,
                      raw: teacher,
                    })),
                  ]
                }
                value={selectedTeacher}
                onChange={(val) => setSelectedTeacher(val || { value: 'all', label: 'Tất cả giáo viên' })}
                isClearable={true}
                isSearchable={true}
                placeholder='Tìm giáo viên...'
                noOptionsMessage={() => 'Không tìm thấy giáo viên'}
                filterOption={(option, input) => {
                  if (!input) return true;
                  const text = input.toLowerCase();
                  const label = (option.label || '').toLowerCase();
                  const value = (option.value || '').toString().toLowerCase();
                  return label.includes(text) || value.includes(text);
                }}
                menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                menuPosition='fixed'
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
              <Form.Text className='text-muted'>
                Chọn "Tất cả giáo viên" để chạy batch cho tất cả, hoặc chọn giáo
                viên cụ thể.
              </Form.Text>
            </Form.Group>

            <Form.Group className='mb-3'>
              <Form.Label>Số tiền (VND)</Form.Label>
              <Form.Control
                type='number'
                value={batchLimit}
                onChange={(e) => setBatchLimit(Number(e.target.value))}
                min='0'
                step='100000'
              />
              <Form.Text className='text-muted'>
                Số tiền tối đa cho mỗi batch (mặc định: 3,000,000 VND)
              </Form.Text>
            </Form.Group>

            <Form.Group className='mb-3'>
              <Form.Label>Loại nhiên liệu</Form.Label>
              <Form.Select
                value={fuelType}
                onChange={(e) => setFuelType(e.target.value)}
              >
                <option value=''>Chọn loại nhiên liệu</option>
                {Object.keys(FUEL_TYPES).map((type) => (
                  <option key={type} value={type}>
                    {FUEL_TYPES[type]}
                  </option>
                ))}
              </Form.Select>
            </Form.Group>

            <div className='border rounded p-3 bg-light'>
              <h6 className='mb-2'>Thông tin batch:</h6>
              <p className='mb-1'>
                <strong>Giáo viên:</strong>{' '}
                {selectedTeacher && selectedTeacher.value === 'all'
                  ? 'Tất cả giáo viên'
                  : selectedTeacher?.label}
              </p>
              <p className='mb-1'>
                <strong>Số tiền:</strong>{' '}
                {new Intl.NumberFormat('vi-VN', {
                  style: 'currency',
                  currency: 'VND',
                }).format(batchLimit)}
              </p>
              <p className='mb-1'>
                <strong>Loại nhiên liệu</strong>{' '}
                {fuelType
                  ? fuelType === 'GASOLINE'
                    ? 'Xăng'
                    : 'Diesel'
                  : 'Chưa chọn'}
              </p>
              <small className='text-warning'>
                <strong>Lưu ý:</strong>
                <br />
                - Việc Nhóm hoá đơn sẽ tạo ra các batch mới dựa trên các hóa đơn
                đã có.
                <br />- Các hoá đơn đã nhóm sẽ không thể thay đổi người nhận
                nhiên liệu.
              </small>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={closeBatchModal}>
            Hủy
          </Button>
          <Button
            variant='warning'
            onClick={confirmAndRunBatch}
            disabled={batchProcessing}
          >
            {batchProcessing ? 'Đang xử lý...' : 'Nhóm hoá đơn'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Confirm Update Modal */}
      <Modal show={showConfirmUpdateModal} onHide={() => setShowConfirmUpdateModal(false)}>
        <Modal.Header closeButton>
          <Modal.Title>Chốt chi nhiên liệu</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className="mb-3">
              <Form.Label>Chọn hạng bằng lái xe</Form.Label>
              <Form.Select
                value={selectedDrivingType}
                onChange={(e) => setSelectedDrivingType(e.target.value)}
              >
                <option value="B">Hạng B (Xăng)</option>
                <option value="C1">Hạng C1 (Dầu)</option>
              </Form.Select>
            </Form.Group>
            <div className="border rounded p-3 bg-light">
              <h6 className="mb-2">Thông tin cập nhật:</h6>
              <p className="mb-1">
                <strong>Loại nhiên liệu hiện tại:</strong>{' '}
                {selectedBatchForUpdate?.DetectedItemType === 'DIESEL' ? 'Dầu Diesel' : 'Xăng'}
              </p>
              <p className="mb-1">
                <strong>Hạng bằng lái xe:</strong>{' '}
                {selectedDrivingType === 'C1' ? 'Hạng C1 (Dầu)' : 'Hạng B (Xăng)'}
              </p>
              {selectedBatchForUpdate?.DetectedItemType === 'DIESEL' && selectedDrivingType === 'B' && (
                <div className="text-danger">
                  <small>
                    <strong>Cảnh báo:</strong> Bạn đang chọn hạng B (Xăng) cho hoá đơn nhiên liệu Diesel
                  </small>
                </div>
              )}
              {selectedBatchForUpdate?.DetectedItemType === 'GASOLINE' && selectedDrivingType === 'C1' && (
                <div className="text-danger">
                  <small>
                    <strong>Cảnh báo:</strong> Bạn đang chọn hạng C1 (Dầu) cho hoá đơn nhiên liệu Xăng
                  </small>
                </div>
              )}
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant="secondary" onClick={() => setShowConfirmUpdateModal(false)}>
            Hủy
          </Button>
          <Button 
            variant="primary" 
            onClick={updateStudentForInvoiceBatch}
            disabled={batchProcessing}
          >
            {batchProcessing ? 'Đang cập nhật...' : 'Xác nhận'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Export Modal */}
      <Modal show={showExportModal} onHide={() => setShowExportModal(false)} size='xl'>
        <Modal.Header closeButton>
          <Modal.Title>Báo cáo đợt chi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Row className='g-3'>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Trạng thái</Form.Label>
                  <Form.Select
                    value={reportStatus?.value || 'all'}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (value === 'all') {
                        setReportStatus({ value: 'all', label: 'Tất cả trạng thái' });
                      } else if (value === 'paid') {
                        setReportStatus({ value: 'paid', label: 'Đã thanh toán' });
                      } else if (value === 'pending') {
                        setReportStatus({ value: 'pending', label: 'Chờ xử lý' });
                      } else if (value === 'cancelled') {
                        setReportStatus({ value: 'cancelled', label: 'Đã hủy' });
                      }
                    }}
                  >
                    <option value='all'>Tất cả trạng thái</option>
                    <option value='paid'>Đã thanh toán</option>
                    <option value='pending'>Chờ xử lý</option>
                    <option value='cancelled'>Đã hủy</option>
                  </Form.Select>
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Giáo viên</Form.Label>
                  <Select
                    options={[
                      { value: 'all', label: 'Tất cả giáo viên' },
                      ...drivingTeachers.map((teacher) => ({
                        value: teacher.code || teacher._id,
                        label: teacher.code || teacher._id,
                      })),
                    ]}
                    value={reportTeacher}
                    onChange={(val) =>
                      setReportTeacher(val || { value: 'all', label: 'Tất cả giáo viên' })
                    }
                    isClearable={true}
                    isSearchable={true}
                    placeholder='Tìm giáo viên...'
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                    menuPosition='fixed'
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className='g-3 mt-1'>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Loại nhiên liệu</Form.Label>
                  <Select
                    options={fuelTypeOptions}
                    value={reportDetectedItemType}
                    onChange={(val) =>
                      setReportDetectedItemType(
                        val || { value: 'all', label: 'Tất cả loại nhiên liệu' }
                      )
                    }
                    isClearable={true}
                    isSearchable={true}
                    placeholder='Chọn loại nhiên liệu...'
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                    menuPosition='fixed'
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Nhóm theo</Form.Label>
                  <Select
                    isMulti
                    options={reportGroupByOptions}
                    value={reportGroupBy}
                    onChange={(val) => setReportGroupBy(val || [])}
                    placeholder='Chọn cột nhóm...'
                    menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                    menuPosition='fixed'
                    styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className='g-3 mt-1'>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Từ ngày (ngày tạo)</Form.Label>
                  <Form.Control
                    type='date'
                    value={reportCreatedStartDate}
                    onChange={(e) => setReportCreatedStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Đến ngày (ngày tạo, bao gồm)</Form.Label>
                  <Form.Control
                    type='date'
                    value={reportCreatedEndDate}
                    onChange={(e) => setReportCreatedEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className='g-3 mt-1'>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Từ ngày (ngày thanh toán)</Form.Label>
                  <Form.Control
                    type='date'
                    value={reportPaidStartDate}
                    onChange={(e) => setReportPaidStartDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
              <Col md={6}>
                <Form.Group>
                  <Form.Label>Đến ngày (ngày thanh toán, bao gồm)</Form.Label>
                  <Form.Control
                    type='date'
                    value={reportPaidEndDate}
                    onChange={(e) => setReportPaidEndDate(e.target.value)}
                  />
                </Form.Group>
              </Col>
            </Row>

            <Row className='g-3 mt-3'>
              <Col md={6}>
                <Form.Check
                  type='checkbox'
                  id='include-content-column'
                  label='Bao gồm cột nội dung'
                  checked={includeContentColumn}
                  onChange={(e) => setIncludeContentColumn(e.target.checked)}
                />
              </Col>
              <Col md={6}>
                <Form.Check
                  type='checkbox'
                  id='include-batch-count-column'
                  label='Bao gồm số đợt chi'
                  checked={includeBatchCountColumn}
                  onChange={(e) => setIncludeBatchCountColumn(e.target.checked)}
                />
              </Col>
            </Row>
            <Row className='g-3 mt-2'>
              <Col md={6}>
                <Form.Check
                  type='checkbox'
                  id='include-gf-student-nlq-column'
                  label='Bao gồm Người nộp HS'
                  checked={includeGfStudentNLQColumn}
                  onChange={(e) => setIncludeGfStudentNLQColumn(e.target.checked)}
                />
              </Col>
            </Row>
            {reportFormat === 'pdf' && (
              <Row className='g-3 mt-2'>
                <Col md={12}>
                  <Form.Group>
                    <Form.Label>Tiêu đề PDF</Form.Label>
                    <Form.Control
                      type='text'
                      placeholder='Nhập tiêu đề PDF (tùy chọn)'
                      value={pdfTitleTemplate}
                      onChange={(e) => setPdfTitleTemplate(e.target.value)}
                    />
                  </Form.Group>
                </Col>
              </Row>
            )}
          </Form>
        </Modal.Body>
        <Modal.Footer className='justify-content-between'>
          <div className='d-flex align-items-center gap-2'>
            <span>Định dạng:</span>
            <Form.Select
              value={reportFormat}
              onChange={(e) => setReportFormat(e.target.value)}
              style={{ width: 140 }}
            >
              <option value='xlsx'>XLSX</option>
              <option value='pdf'>PDF</option>
            </Form.Select>
          </div>
          <div className='d-flex gap-2'>
            <Button variant='secondary' onClick={() => setShowExportModal(false)}>
              Đóng
            </Button>
            <Button variant='success' onClick={exportBatches} disabled={exporting}>
              {exporting ? 'Đang xuất...' : 'Xuất báo cáo'}
            </Button>
          </div>
        </Modal.Footer>
      </Modal>

      {/* Multi-Batch Payment Voucher Export Modal */}
      <Modal
        show={showExportPaymentVoucherModal}
        onHide={() => setShowExportPaymentVoucherModal(false)}
        size='lg'
      >
        <Modal.Header closeButton>
          <Modal.Title>Xuất phiếu chi cho nhiều batch</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form>
            <Form.Group className='mb-3'>
              <Form.Label>Chọn giáo viên</Form.Label>
              <Select
                options={
                  [
                    { value: 'all', label: 'Tất cả giáo viên' },
                    ...drivingTeachers.map((teacher) => ({
                      value: teacher.code || teacher._id,
                      label: teacher.code || teacher._id,
                    })),
                  ]
                }
                value={paymentVoucherTeacher}
                onChange={(val) => setPaymentVoucherTeacher(val || { value: 'all', label: 'Tất cả giáo viên' })}
                isClearable={true}
                isSearchable={true}
                placeholder='Tìm giáo viên...'
                menuPortalTarget={typeof document !== 'undefined' ? document.body : undefined}
                menuPosition='fixed'
                styles={{ menuPortal: (base) => ({ ...base, zIndex: 9999 }) }}
              />
            </Form.Group>

            <Form.Group className='mb-3'>
              <Form.Label>Từ ngày (ngày thanh toán)</Form.Label>
              <Form.Control
                type='date'
                value={paymentVoucherStartDate}
                onChange={(e) => setPaymentVoucherStartDate(e.target.value)}
              />
            </Form.Group>

            <Form.Group className='mb-3'>
              <Form.Label>Đến ngày (ngày thanh toán, bao gồm)</Form.Label>
              <Form.Control
                type='date'
                value={paymentVoucherEndDate}
                onChange={(e) => setPaymentVoucherEndDate(e.target.value)}
              />
            </Form.Group>

            <Form.Group className='mb-3'>
              <Form.Label>Cách bố trí dòng cho hoá đơn</Form.Label>
              <Form.Check
                type='radio'
                id='pv-layout-per-invoice-merged'
                name='paymentVoucherLayout'
                label='1 dòng / hoá đơn — gộp cột chung của cùng batch (khuyến nghị)'
                checked={paymentVoucherLayout === 'per-invoice-merged'}
                onChange={() => setPaymentVoucherLayout('per-invoice-merged')}
              />
              <Form.Check
                type='radio'
                id='pv-layout-per-invoice'
                name='paymentVoucherLayout'
                label='1 dòng / hoá đơn — STT chạy liên tục, học viên/khoá lặp lại'
                checked={paymentVoucherLayout === 'per-invoice'}
                onChange={() => setPaymentVoucherLayout('per-invoice')}
              />
              <Form.Check
                type='radio'
                id='pv-layout-concat'
                name='paymentVoucherLayout'
                label='Gộp 1 dòng / batch — nhiều hoá đơn nối bằng "; "'
                checked={paymentVoucherLayout === 'concat'}
                onChange={() => setPaymentVoucherLayout('concat')}
              />
              {(paymentVoucherLayout === 'per-invoice' || paymentVoucherLayout === 'per-invoice-merged') && (
                <div className='alert alert-warning mt-2 mb-0 py-2 px-3' role='alert'>
                  <strong>Cảnh báo:</strong> Với hoá đơn bị tách (split invoice),
                  cột <em>Số tiền chi</em> ghi đầy đủ giá trị của hoá đơn,{' '}
                  <strong>không trừ phần đã chuyển sang batch khác</strong>.
                  Tổng cột này có thể không khớp ô <em>Số tiền:</em> ở header.
                  Hãy kiểm tra thủ công trước khi in.
                </div>
              )}
            </Form.Group>

            <div className='border rounded p-3 bg-light'>
              <h6 className='mb-2'>Thông tin xuất phiếu chi:</h6>
              <p className='mb-1'>
                <strong>Giáo viên:</strong>{' '}
                {paymentVoucherTeacher && paymentVoucherTeacher.value === 'all'
                  ? 'Tất cả giáo viên'
                  : paymentVoucherTeacher?.label}
              </p>
              <p className='mb-1'>
                <strong>Từ ngày:</strong> {paymentVoucherStartDate || 'Chưa chọn'}
              </p>
              <p className='mb-1'>
                <strong>Đến ngày:</strong> {paymentVoucherEndDate || 'Chưa chọn'}
              </p>
              <p className='mb-1'>
                <strong>Bố trí:</strong>{' '}
                {paymentVoucherLayout === 'per-invoice-merged'
                  ? '1 dòng / hoá đơn — gộp cột chung'
                  : paymentVoucherLayout === 'per-invoice'
                  ? '1 dòng / hoá đơn'
                  : 'Gộp 1 dòng / batch'}
              </p>
              <small className='text-info d-block mt-2'>
                <strong>Lưu ý:</strong> Phiếu chi sẽ được xuất cho tất cả các batch đã thanh toán phù hợp với điều kiện đã chọn.
              </small>
            </div>
          </Form>
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowExportPaymentVoucherModal(false)}>
            Hủy
          </Button>
          <Button
            variant='primary'
            onClick={exportMultiBatchPaymentVouchers}
            disabled={exportingPaymentVoucher || !paymentVoucherStartDate || !paymentVoucherEndDate}
          >
            {exportingPaymentVoucher ? 'Đang xuất...' : 'Xuất phiếu chi'}
          </Button>
        </Modal.Footer>
      </Modal>

      {/* Single-Batch Payment Voucher Export Modal */}
      <Modal
        show={showSingleVoucherModal}
        onHide={() => setShowSingleVoucherModal(false)}
      >
        <Modal.Header closeButton>
          <Modal.Title>Xuất phiếu chi</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {singleVoucherBatch && (
            <>
              <div className='mb-3'>
                <p className='mb-1'><strong>Học viên:</strong> {singleVoucherBatch.GfStudentName || '—'}</p>
                <p className='mb-1'><strong>Khoá:</strong> {singleVoucherBatch.GfStudentCourse || '—'}</p>
                <p className='mb-1'><strong>Người nhận NL:</strong> {singleVoucherBatch.DrivingTeacher || '—'}</p>
                <p className='mb-1'><strong>Số tiền:</strong> {Number(singleVoucherBatch.TotalAmount || 0).toLocaleString('vi-VN')} đồng</p>
                <p className='mb-1'><strong>Số hoá đơn trong batch:</strong> {singleVoucherBatch.InvoiceCount ?? (Array.isArray(singleVoucherBatch.InvoiceIds) ? singleVoucherBatch.InvoiceIds.length : '—')}</p>
              </div>

              <Form.Group className='mb-2'>
                <Form.Label>Cách bố trí dòng cho hoá đơn</Form.Label>
                <Form.Check
                  type='radio'
                  id='single-pv-layout-per-invoice-merged'
                  name='singleVoucherLayout'
                  label='1 dòng / hoá đơn — gộp cột chung của cùng batch (khuyến nghị)'
                  checked={singleVoucherLayout === 'per-invoice-merged'}
                  onChange={() => setSingleVoucherLayout('per-invoice-merged')}
                />
                <Form.Check
                  type='radio'
                  id='single-pv-layout-per-invoice'
                  name='singleVoucherLayout'
                  label='1 dòng / hoá đơn'
                  checked={singleVoucherLayout === 'per-invoice'}
                  onChange={() => setSingleVoucherLayout('per-invoice')}
                />
                <Form.Check
                  type='radio'
                  id='single-pv-layout-concat'
                  name='singleVoucherLayout'
                  label='Gộp 1 dòng / batch — nhiều hoá đơn nối bằng "; "'
                  checked={singleVoucherLayout === 'concat'}
                  onChange={() => setSingleVoucherLayout('concat')}
                />
              </Form.Group>

              {(singleVoucherLayout === 'per-invoice' || singleVoucherLayout === 'per-invoice-merged') && (
                <div className='alert alert-warning mt-2 mb-0 py-2 px-3' role='alert'>
                  <strong>Cảnh báo:</strong> Với hoá đơn bị tách (split invoice),
                  cột <em>Số tiền chi</em> ghi đầy đủ giá trị của hoá đơn,{' '}
                  <strong>không trừ phần đã chuyển sang batch khác</strong>.
                  Tổng cột này có thể không khớp ô <em>Số tiền:</em> ở header.
                  Hãy kiểm tra thủ công trước khi in.
                </div>
              )}

              {singleVoucherBatch.SplitInvoiceId && (
                <div className='alert alert-info mt-2 mb-0 py-2 px-3' role='alert'>
                  <strong>Lưu ý:</strong> Batch này có hoá đơn bị tách (SplitInvoiceId).
                  Phần dư <strong>{Number(singleVoucherBatch.RemainingAmount || 0).toLocaleString('vi-VN')} đồng</strong>{' '}
                  đã chuyển sang batch khác. Cân nhắc kiểm tra trước khi in.
                </div>
              )}
            </>
          )}
        </Modal.Body>
        <Modal.Footer>
          <Button variant='secondary' onClick={() => setShowSingleVoucherModal(false)}>
            Hủy
          </Button>
          <Button
            variant='primary'
            onClick={() => handleExportPaymentVoucher(singleVoucherBatch, singleVoucherLayout)}
            disabled={exporting || !singleVoucherBatch}
          >
            {exporting ? 'Đang xuất...' : 'Xuất phiếu chi'}
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
}

export default MeInvoiceBatchPage;
